module.exports = __webpack_public_path__ + "img/inventory-control-list.3439d934.svg";